import { AttachmentsProvider } from "@RequestFormV2/sections/Attachments/context/AttachmentsProvider";
import AttachmentsUploadSection from "@RequestFormV2/sections/Attachments/components/AttachmentsUploadSection";

export default function Attachments() {
  return (
    <AttachmentsProvider>
      <AttachmentsUploadSection />
    </AttachmentsProvider>
  );
}
